export default "__VITE_ASSET__CaLDvrg0__"